import React, { useState } from 'react'
import { IconButton } from '@mui/material'
import { ExpandMore, ExpandLess } from '@mui/icons-material'
import styled from 'styled-components'

import { removeScriptTags } from 'helpers/formatters'
import { screenSize } from 'styles/shared'

type Props={
  text: string
}

const CollapsibleParagraph = ({ text }: Props) => {
  const [expanded, setExpanded] = useState(false)

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  return (
    <S.MessageContainer>
      <S.SingleLineMessage
        noWrap={!expanded}
        dangerouslySetInnerHTML={{
          __html: removeScriptTags(text)
        }}
      />

      <IconButton onClick={handleExpandClick} aria-expanded={expanded}>
        {expanded ? <ExpandLess /> : <ExpandMore />}
      </IconButton>
    </S.MessageContainer>
  )
}

export default CollapsibleParagraph

const S = {
  MessageContainer: styled.div`
    display:flex;
    align-items: center;
    max-width: 400px;
    @media ${screenSize.small} {
      max-width: 340px;
    }
  `,
  SingleLineMessage: styled.div.withConfig({
    shouldForwardProp: (prop) => !['noWrap'].includes(prop)
  })<{ noWrap: boolean }>`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: ${({ noWrap }) => noWrap ? 'nowrap' : 'normal'};
  `
}
